import React, { useState , useEffect}  from 'react';
import { MdPlayArrow, MdSave, MdDelete, MdClearAll } from 'react-icons/md';
import {useRutasMutations} from '../../hooks/rutas/useRutasMutations';
import { getRegistroRutas } from '../../services/RegistroRutas';
import { SearchCliente } from '../../components';
import { SearchRecolector } from '../../components';

import { fetchUser } from '../../utils/fetchUser';
import { Toaster,toast } from 'react-hot-toast';
import {getRecolectoresRut, getRecolectoresId} from "../../services/Recolectores";

import OpenLayersMap from '../../components/OpenLayersMap/OpenLayersMap';
import { fi } from 'date-fns/locale';



const initialState = {
_id: null,
empresa: null,
idRecolector: null,
rut: '',
nombreRecolector: '',
idComuna: null,
nombreComuna: '',
nombreCiudad: '',
rutaRepartidor: [],
fechaCreacion:'',
};

const RegistroRutas = () => {
  const [formData, setFormData] = useState(initialState);
  const { addRuta, updateRutaD, removeRuta } = useRutasMutations();
  const [clientes, setClientes] = useState([]);
  const [rutaCalculada, setRutaCalculada] = useState([]);
  const [filtroPlan, setFiltroPlan] = useState('Todos');
  const [idRuta, setIdRuta] = useState(null);
  const [diaRuta, setDiaRuta] = useState('Lunes');
  const userInfo = fetchUser();

  const [todasLasRutas, setTodasLasRutas] = useState([]);     // Todo lo que viene del backend (para todos los días)
  const [rutasFiltradas, setRutasFiltradas] = useState([]);   // Lo que se muestra en tabla

  const handleChangediaRuta = (e) =>{
    const dia = e.target.value;
    setDiaRuta(dia);
    // Filtra SIN ir al servidor
    const filtradas = todasLasRutas.filter(r => r.diaRuta?.toLowerCase() === dia.toLowerCase());
    // setRutasFiltradas(filtradas);

    setClientes(filtradas);
    calcularRuta(filtradas);
  }

  const leerDatos = async () => {
    try {

      if (formData.rut === '') {
        toast.error("Ingrese un rut para continuar");
        return;
      }

      const mockClientes = await getRegistroRutas(formData.idRecolector);
      // console.log("LEI EL CLIENTE " + JSON.stringify(mockClientes));
      // console.log("LEI EL CLIENTE RUTA " + JSON.stringify(mockClientes[0].rutaRepartidor));
      if (mockClientes.length > 0) {

        // Une todos los días y todas las rutas
        const todas = mockClientes.flatMap(d => d.rutaRepartidor.map(r => ({
          ...r,
          diaRuta: r.diaRuta || d.diaRuta || ""   // seguridad
        })));

        setTodasLasRutas(todas);
        // Filtra según el select actual
        const filtradas = todas.filter(r => r.diaRuta?.toLowerCase() === diaRuta.toLowerCase());
        setRutasFiltradas(filtradas);


        setIdRuta(mockClientes[0]._id);
        setClientes(filtradas);
        calcularRuta(filtradas);
        // setClientes(mockClientes[0].rutaRepartidor);
        // calcularRuta(mockClientes[0].rutaRepartidor);
      };
      //aplicarFiltro(, filtroPlan);     
    } catch (error) {
      console.log("Problemas al momento de Leer Datos, contacte a soporte" + error);
      toast.error("Problemas al momento de Leer Datos, contacte a soporte");  
    }
  };

  const leerAutomatico = async (idRecolector) => {
    try {

      const mockClientes = await getRegistroRutas(idRecolector);
      //console.log("LEI EL CLIENTE " + JSON.stringify(mockClientes));
      if (mockClientes.length > 0) {
        setIdRuta(mockClientes[0]._id);
        const todas = mockClientes.flatMap(d => d.rutaRepartidor.map(r => ({
          ...r,
          diaRuta: r.diaRuta
        })));
        setTodasLasRutas(todas);
        // Filtra según día actual
        const filtradas = todas.filter(r => r.diaRuta?.toLowerCase() === diaRuta.toLowerCase());
        setRutasFiltradas(filtradas);

        setClientes(filtradas);
        // setClientes(mockClientes[0].rutaRepartidor);
      }
    //  aplicarFiltro(mockClientes.rutaRepartidor, filtroPlan);     
    } catch (error) {
      console.log("Problemas al momento de Leer Datos, contacte a soporte" + error);
      toast.error("Problemas al momento de Leer Datos, contacte a soporte");  
    }
  };

  useEffect(() => {

   const fetchData = async () => {
      const miCliente = await getRecolectoresId(userInfo.usuario);
      if (miCliente.length > 0) {
          setFormData((prev) => ({
            ...prev,
            nombreRecolector: miCliente[0].nombreRecolector, idRecolector: miCliente[0]._id,
            nombreComuna: miCliente[0].nombreComuna, nombreCiudad: miCliente[0].nombreCiudad,
          }));
          leerAutomatico(miCliente[0]._id);
      };
    };

    if (userInfo.rol === "Partner") {
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const miCliente = await getRecolectoresRut(formData.rut);
      if (miCliente.length > 0) {
          setFormData((prev) => ({
            ...prev,
            nombreRecolector: miCliente[0].nombreRecolector, idRecolector: miCliente[0]._id,
            nombreComuna: miCliente[0].nombreComuna, nombreCiudad: miCliente[0].nombreCiudad,
          }));
          leerAutomatico(miCliente[0]._id);
      };
    };
    if(formData.rut !== '') {
      // Lee datos cliente usando API por rut
      fetchData();
    }
  }, [formData.rut]);

  useEffect(() => {
    if (clientes && clientes.length > 0) {
      calcularRuta(clientes);
    }
  }, [clientes]);

  const handleEliminarCliente = (idCliente) => {
    const nuevosClientes = clientes.filter((c) => c._id !== idCliente);
    setClientes(nuevosClientes); // actualiza los clientes
  };
  
  const guardarRuta = async () => {
  try {
      if (rutaCalculada.length === 0) {
        toast.error("No hay ruta calculada para guardar");
        return;}
        
        if (formData.rut === '') {
          toast.error("Ingrese un rut para continuar");
          return;
        }

        const arregloFinal = rutaCalculada.map((cliente, index) => ({
          orden: index + 1,
          diaRuta: diaRuta,
          idRegistroPlan: cliente._id,
        }));
        
        if (!formData._id) {
          const datosRuta = {
            empresa: userInfo.empresa,
            idRecolector: formData.idRecolector,
            rutaRepartidor: arregloFinal,
            fechaCreacion: Date.now(),
          };
          await addRuta.mutateAsync(datosRuta);
        } else {

          const datosRuta = {
            id: formData._id,
            empresa: userInfo.empresa,
            idRecolector: formData.idRecolector,
            rutaRepartidor: arregloFinal,
            fechaCreacion: Date.now(),
          };
          //console.log("Datos a actualizar: " + JSON.stringify(datosRuta));
          await updateRutaD.mutateAsync(datosRuta);
        }
        toast.success("Ruta guardada correctamente");

        limpiarFormulario();
      } catch (error) {
        console.log("Problemas al momento de Guardar Ruta, contacte a soporte" + error);
        toast.error("Problemas al momento de Guardar Ruta, contacte a soporte");  
      }
  };

const limpiarFormulario = () => {
  setClientes([]);
  setRutaCalculada([]);
  setFormData(initialState);
  setIdRuta(null);
  setFiltroPlan('Todos');
  setDiaRuta('Lunes');
  setTodasLasRutas([]);
  setRutasFiltradas([]);
 };
 
  const eliminarRuta = async () => {

    if (idRuta === '' || idRuta === null) {
      toast.error("Seleccione una ruta para eliminar");
      return;
    }
    try {
     
      await removeRuta.mutateAsync(idRuta);
      limpiarFormulario();
      toast.success("Ruta eliminada correctamente");

    } catch (error) {
      console.log("Problemas al momento de Eliminar Ruta, contacte a soporte" + error);
      toast.error("Problemas al momento de Eliminar Ruta, contacte a soporte");   
    }
  };

  const aplicarFiltro = (clienteNuevo, plan) => {
    const filtrados = [clienteNuevo].filter((cli) =>
      !plan || cli.nombrePlan === plan
    );
    
    if (!Array.isArray(filtrados)) {
      console.error("clientesFiltrados no es un array");
      return;
    }
  
    calcularRuta(filtrados); // asegúrate que filtrados es un array
  };
  
  const calcularRuta = (clientesFiltrados) => {
    // Garantizar que sea un array
    const lista = Array.isArray(clientesFiltrados)
      ? clientesFiltrados
      : [clientesFiltrados];
  
    const ordenados = [...lista].sort((a, b) => a.lat - b.lat);
    setRutaCalculada(ordenados);
  };
  
  const handleFiltroChange = (e) => {
    const nuevoFiltro = e.target.value;
    setFiltroPlan(nuevoFiltro);
    aplicarFiltro(clientes, nuevoFiltro);
  };

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";
  
  const botones = [
    {
      label: 'Leer',
      icon: <MdPlayArrow className="text-2xl" />,
      onClick: leerDatos,
      color: 'text-blue-600 hover:bg-blue-100',
      enabled: userInfo.rol === "Partner" ? false : true,
    },
    {
      label: 'Guardar',
      icon: <MdSave className="text-2xl" />,
      onClick: guardarRuta,
      color: 'text-green-600 hover:bg-green-100',
      enabled: rutaCalculada.length > 0,
    },
    {
      label: 'Eliminar',
      icon: <MdDelete className="text-2xl" />,
      onClick: eliminarRuta,
      color: 'text-red-600 hover:bg-red-100',
      enabled: rutaCalculada.length > 0,
    },
    {
      label: 'Limpiar',
      icon: <MdClearAll className="text-2xl" />,
      onClick: limpiarFormulario,
      color: 'text-gray-600 hover:bg-gray-100',
      enabled: userInfo.rol === "Partner" ? false : true,
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };  

  const handleSubmit = async () =>{
    
  }

  return (
    <form  onSubmit={handleSubmit} >
        <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">
        <div className="container mx-auto p-2 md:p-2">

        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Programar Rutas
              </p>
            </div>

            <div className="flex flex-wrap gap-3 mt-4">
              <SearchCliente estado='Activo' idRecolector={formData.idRecolector}
              onValorSeleccionadoChange={(cliSeleccionado) => {
                if (!cliSeleccionado) return;

                setClientes(prev => {
                  const existe = prev.some(c => c._id === cliSeleccionado._id);
                  if (existe) return prev;
                
                  return [...prev, {
                    _id: cliSeleccionado._id,
                    rutCliPro: cliSeleccionado.rutCliPro,
                    razonSocial: cliSeleccionado.razonSocial,
                    nombrePlan: cliSeleccionado.nombrePlan,
                    frecuencia: cliSeleccionado.frecuencia,
                    nombreComuna: cliSeleccionado.nombreComuna,
                    direccion: cliSeleccionado.direccion,
                    lat: cliSeleccionado.lat,
                    lng: cliSeleccionado.lng,
                  }];
                });
                

              }}
               />
              {userInfo.rol !== "Partner" && 
              <SearchRecolector estado='Activo'
              onValorSeleccionadoChange={(cliSeleccionado) => {   
                if (!cliSeleccionado) return;
                setFormData((prev) => ({
                  ...prev,
                  rut: cliSeleccionado.rut,
                  nombreRecolector: cliSeleccionado.nombreRecolector,
                  idRecolector: cliSeleccionado.idRecolector,
                  nombreComuna: cliSeleccionado.nombreComuna,
                  nombreCiudad: cliSeleccionado.nombreCiudad,
                }));
                //  Debe Leer
                leerAutomatico(cliSeleccionado._id);
              }}
              />
              }
              {botones.map((btn, i) => (  
                <button
                  key={i}
                  type="button"
                  onClick={btn.onClick}
                  disabled={!btn.enabled}
                  className={`flex flex-col items-center justify-center p-3 rounded transition-colors ${
                    btn.enabled
                      ? `${btn.color} cursor-pointer`
                      : 'opacity-40 cursor-not-allowed'
                  }`}
                >
                  {btn.icon}
                  <span className="text-[10px] mt-1 hidden md:block text-center leading-tight">
                    {btn.label}
                  </span>
                </button>
              ))}
            </div>

          </div>

     <div className="bg-gray-200 p-6 rounded-lg shadow-lg mt-2">

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" >
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Día Ruta</label>
                <select className="text-xs border border-gray-300 p-2 rounded" name="diaRuta" value= {diaRuta} required onChange={handleChangediaRuta}>   
                  <option value="Lunes">Lunes</option>
                  <option value="Martes">Martes</option>
                  <option value="Miércoles">Miércoles</option>  
                  <option value="jueves">Jueves</option>  
                  <option value="Viernes">Viernes</option>
                  <option value="Sábado">Sábado</option>      
                </select>
            </div>  
      {userInfo.rol !== "Partner" &&
        <> 
            <div className="flex flex-col">
              <label className="text-xs font-semibold mb-1">Rut Recolector</label>
              <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="rut"
                  value= {formData.rut}
                  required
                  onChange={handleChange}
                  disabled = {userInfo.rol === "Partner" ? true : false}
                />
            </div>
            <div className="col-span-3">
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Nombre</label>
                <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreRecolector"
                    value= {formData.nombreRecolector}
                    disabled
                    onChange={handleChange}
                  />
              </div>
            </div>
        </>
        }
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >

            <div className="mt-6 bg-white rounded-lg shadow overflow-auto">
                <table className="min-w-full text-sm text-gray-700">
                    <thead className="bg-gray-100 text-xs uppercase tracking-wider text-gray-600">
                    <tr>
                        <th className="px-4 py-2 text-left"></th>
                        <th className="px-4 py-2 text-left">Rut</th>
                        <th className="px-4 py-2 text-left">Cliente</th>
                        <th className="px-4 py-2 text-left">Plan</th>
                        <th className="px-4 py-2 text-left">Frecuencia</th>
                        <th className="px-4 py-2 text-left">Comuna</th>
                        <th className="px-4 py-2 text-left">Dirección</th>
                    </tr>
                    </thead>
                    <tbody>
                    {rutaCalculada.map((punto) => (
                        <tr key={punto._id} className="border-t hover:bg-gray-50">
                        <td className="px-4 py-2">
                          <button
                          type="button"
                            onClick={() => handleEliminarCliente(punto._id)}
                            className="text-red-500 hover:text-red-700"
                            title="Eliminar"
                          >
                            <MdDelete size={20} />
                          </button>
                        </td>
                        <td className={`${inputClass} whitespace-nowrap`}>{punto.rutCliPro}</td>
                        <td className={inputClass}>{punto.razonSocial}</td>
                        <td className={inputClass}>{punto.nombrePlan}</td>
                        <td className={inputClass}>{punto.frecuencia}</td>
                        <td className={inputClass}>{punto.nombreComuna}</td>
                        <td className={inputClass}>{punto.direccion}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

        </div>    
    </div>   

    <div className="mt-5 space-y-4">
          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >


              <div className="p-4 space-y-4">
                  {/* Botones */}
                  <div className="flex flex-wrap gap-4 items-center">

                    {/* Filtro */}
                    <select
                      className="border px-2 py-1 rounded text-sm"
                      value={filtroPlan}
                      onChange={handleFiltroChange}
                    >
                      <option value="Todos">Todos</option>
                      <option value="Diario">Diario</option>
                      <option value="Semanal">Semanal</option>
                      <option value="Mensual">Mensual</option>
                    </select>
                  </div>

                  {/* Mapa */}
                  <OpenLayersMap puntos={rutaCalculada} />
              </div>

            </div>

          </div>

      </div>   
      <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
      </div>

    </div>
</form>
  );
};

export default RegistroRutas;